import axios from '../axios'

const phoneModelProperties = params => {
  return axios({
    url: '/customer/recycle/product/param',
    method: 'get',
    params
  })
}
const evaluation = data => {
  return axios({
    url: '/customer/recycle/product/simpleTemplate/evaluation',
    method: 'post',
    data
  })
}



export {
  phoneModelProperties,
  evaluation
}
